import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import useCurrentOrg from '@/lib/hooks/swr/useCurrentOrg';
import translate from '@/lib/intl/translate';
import getInitials from '@/utils/getInitials';

const useCompanyNavListItem = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  const { data } = useCurrentOrg();
  const avatar = data?.avatar || '';
  const orgName = data?.orgName || '';

  const itemText = React.useMemo(
    () => (isDesktop ? '' : translate('COMPANY_TITLE')),
    [isDesktop],
  );

  return {
    avatar,
    orgName,
    orgNameInitials: getInitials(orgName, false),
    itemText,
  };
};

export default useCompanyNavListItem;
